import {useContext, useEffect, useState} from "react";
import {AgentContext} from "../context/agent-context.jsx";
import AttachShow from "../../../../../components/attach/attach-show.jsx";
import {FaEye} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";

const CellRendererAttach = ({attachId, itemId, target}) => {
    const {tablesAttachs} = useContext(AgentContext);
    const [openModal, setOpenModal] = useState(false)
    const [file, setFile] = useState(null);

    useEffect(() => {
        const prefix = `attach-${target}-${itemId}.`;

        const attachFind = tablesAttachs.find(a => a?.name?.startsWith(prefix));
        if (attachFind) setFile(attachFind);
    }, []);

    return (
        <>
            <div className={"w-full flex justify-center items-center h-full"}>
                {
                    (attachId || file) &&
                    <Button className={"!w-[30px] !h-[25px] !p-0"} title={"Visualizar anexo"} onClick={() => setOpenModal(true)}>
                        <FaEye />
                    </Button>
                }
            </div>

            <AttachShow
                newFileShow={file}
                setFile={setFile}
                attachId={attachId}
                open={openModal}
                setOpen={setOpenModal}
                remove={undefined}
                showRemove={false}
                newOpen={!!file}
            />
        </>
    );
}

export default CellRendererAttach;